import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import { addRiskRegisterForm } from "./actions.js";
import attachables from "./attachables.js";

export default [{
    "path": "/SafetyManagement/RiskRegister",
    "component": { ...ItemListView },
    "name": "Risk Register",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": false,
        "sideNavSection": "Safety and Risk Management",
        "name": "Risk Register",
        "tableSettings": "RiskRegister",
        "dataPath": "SafetyManagement/RiskRegister",
        "selectionRoute": "SafetyManagement/RiskRegister/{ID}",
        "menuActions": [{
            "label": "Add Risk Register Form",
            "action": addRiskRegisterForm
        }]
    }
}, {
    "path": "/SafetyManagement/RiskRegister/:id",
    "component": ItemView,
    "name": "Risk Register Entry",
    "meta": {
        "app": "SafetyManagement",
        "name": "Risk Register Entry",
        "dataPath": "SafetyManagement/RiskRegister",
        "storeData": ["Database/DocumentTypes", "SafetyManagement/Categories"],
        "title": (item) => `Risk Register: ${item.Number}`,
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-2"
        }, {
            "label": "Latest Revision",
            "key": "Revision",
            "type": "text",
            "actionButton": true,
            "actionText": "Download",
            async action({ pageItem, db }) {
                let url = await db.download(`Database/RiskReg/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${pageItem.Revisions[pageItem.RevisionID].File}`);
                window.open(url, "fileView", "popup");
            }
        }],
        "menuActions": [],
        "attachedItems": {
            "Details": {
                "attachables": attachables
            }
        }
    }
}];
